import React from 'react'
import Image from 'next/image'
import useTranslation from 'next-translate/useTranslation'
import { Button } from 'components/Button'
import { Text } from 'components/Text'
import {
  CustomMealPlanRoot,
  BackgroundImage,
  DesktopImage,
  MobileImage,
  DescriptionWrapper,
} from '../../../FivePound/components/CustomMealPlan/CustomMealPlan.styles'
import background from '../../../../../../../../public/assets/product/feedGreatBackground.webp'
import backgroundMobile from '../../../../../../../../public/assets/product/feedGreatBackgroundMobile.webp'
import Trans from 'next-translate/Trans'
import Link from 'next/link'
import { ContentWrapper, Spacer, FeedGreatRoot } from './FeedGreat.styles'

export const FeedGreat: React.FC = () => {
  const { t } = useTranslation('products')

  return (
    <FeedGreatRoot>
      <BackgroundImage>
        <DesktopImage>
          <Image src={background} alt={t('recipes:individual.expect.background-img')} />
        </DesktopImage>
        <MobileImage>
          <Image src={backgroundMobile} alt={t('recipes:individual.expect.background-img')} />
        </MobileImage>
        <ContentWrapper>
          <Text
            as="h2"
            align="left"
            size="h2"
            weight="semiBold"
            color="accent-white"
            css={{ marginBottom: '$2' }}
          >
            {t('products:startr.feedGreat.title')}
          </Text>
          <Text
            align="left"
            size={{ '@initial': 'headline', '@bp2': 'h5' }}
            color="accent-white"
            css={{ marginBottom: '$4' }}
          >
            <Trans i18nKey={'products:startr.feedGreat.description'} components={{ br: <br /> }} />
          </Text>
          <Link href="/products/treats">
            <Button>{t('products:startr.feedGreat.cta')}</Button>
          </Link>
        </ContentWrapper>
      </BackgroundImage>
      <DescriptionWrapper css={{ gap: '$2' }}>
        <Text size="h2" color="accent-white" align="center" weight="semiBold">
          <Trans
            i18nKey={t('products:startr.feedGreat.title-mobile')}
            components={{ br: <br /> }}
          />
        </Text>
        <Text align="center" weight="semiBold" size="headline" color="accent-white">
          <Trans i18nKey={'products:startr.feedGreat.description'} components={{ br: <br /> }} />
        </Text>
        <Link href="/products/treats">
          <Button>{t('products:startr.feedGreat.cta')}</Button>
        </Link>
        <Spacer />
      </DescriptionWrapper>
    </FeedGreatRoot>
  )
}
